import { HTTP_CODE } from '@/utils/request'
import * as service from './service'
import Toast from 'antd-mobile/es/toast'
export default {
  namespace: 'propMyPropDetail',
  state: {
    demoData: {}
  },
  effects: {
    * courierPropRecord ({ payload }, { call, put }) {
      try {
        const res = yield call(service.courierPropRecord, payload)
        if (res.status !== HTTP_CODE.success) {
          console.error(res.data.err)
        } else {
          return res.data
        }
      } catch (err) {
        console.log(err, 'lllllll')
      }
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
